import WalletErrorHandler from '@/modules/access-wallet/common/WalletErrorHandler';

const ERRORS = {};
const WARNINGS = {};

export default WalletErrorHandler(ERRORS, WARNINGS);
